import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";

export default function ProgramDialog({
  open,
  onOpenChange,
  editing,
  form,
  setForm,
  phases,
  onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#171717] border-[#262626] text-white max-w-md"
        data-testid="program-dialog"
      >
        <DialogHeader>
          <DialogTitle
            className="font-bold tracking-tight uppercase"
            style={{ fontFamily: "Barlow Condensed, sans-serif" }}
          >
            {editing ? "MODIFICA PROGRAMMA" : "NUOVO PROGRAMMA"}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">
              Titolo
            </Label>
            <Input
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
              placeholder="es. Programma Settimana 1-4"
              data-testid="program-title"
            />
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">
              Fase del percorso
            </Label>
            <Select
              value={form.phase_id || "none"}
              onValueChange={(v) =>
                setForm({ ...form, phase_id: v === "none" ? "" : v })
              }
            >
              <SelectTrigger
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="program-phase-select"
              >
                <SelectValue placeholder="Nessuna fase" />
              </SelectTrigger>
              <SelectContent className="bg-[#171717] border-[#262626]">
                <SelectItem value="none" className="text-white">
                  Nessuna fase
                </SelectItem>
                {phases.map((p) => (
                  <SelectItem key={p.id} value={p.id} className="text-white">
                    {p.title}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-zinc-400 text-xs uppercase tracking-wider">
              Descrizione
            </Label>
            <Textarea
              value={form.description}
              onChange={(e) =>
                setForm({ ...form, description: e.target.value })
              }
              className="mt-1 bg-[#0A0A0A] border-[#262626] text-white min-h-[60px] resize-none"
              data-testid="program-description"
            />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">
                Inizio
              </Label>
              <Input
                type="date"
                value={form.start_date || ""}
                onChange={(e) =>
                  setForm({ ...form, start_date: e.target.value })
                }
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="program-start-date"
              />
            </div>
            <div>
              <Label className="text-zinc-400 text-xs uppercase tracking-wider">
                Fine
              </Label>
              <Input
                type="date"
                value={form.end_date || ""}
                onChange={(e) =>
                  setForm({ ...form, end_date: e.target.value })
                }
                className="mt-1 bg-[#0A0A0A] border-[#262626] text-white"
                data-testid="program-end-date"
              />
            </div>
          </div>
          <p className="text-[11px] text-zinc-600 -mt-2">
            Imposta date per oscurare automaticamente il programma quando termina (anche dentro a una fase ancora attiva).
          </p>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="border-[#262626] text-zinc-300 hover:bg-[#1A1A1A]"
            data-testid="program-cancel"
          >
            Annulla
          </Button>
          <Button
            onClick={onSave}
            className="bg-[#007AFF] hover:bg-[#3395FF] text-white"
            data-testid="program-save"
          >
            {editing ? "Aggiorna" : "Crea"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
